import React, { useMemo } from 'react';
import { Socket } from 'socket.io-client';
import { socket } from '../store';

interface Context {
  socket: Socket;
}

export const ChatContext = React.createContext<Context | null>(null);

interface Props {
  socketUrl?: string;
  children: React.ReactNode;
}

export const ChatContextProvider: React.FC<Props> = ({ children }) => {
  const value = useMemo(() => {
    return { socket };
  }, []);

  return <ChatContext.Provider value={value}>{children}</ChatContext.Provider>;
};
